import { BaseToast, ErrorToast, InfoToast, SuccessToast, ToastConfig } from 'react-native-toast-message'

/**
 * The library's defaults cut every toast off after one line of body text and fix the height at
 * 60px, so any message that said what the problem was *and* what to do about it lost the second
 * half — "You already have unavailability booked over these dates...." with the rest gone.
 *
 * Nothing here changes the look: same colours, same layout, just room to finish the sentence.
 */
const roomForABodyLine = {
  style: { height: 'auto' as const, minHeight: 60, paddingVertical: 10 },
  text2NumberOfLines: 3,
  text2Style: { fontSize: 13 },
}

export const toastConfig: ToastConfig = {
  success: props => <SuccessToast {...props} {...roomForABodyLine} />,
  error: props => <ErrorToast {...props} {...roomForABodyLine} />,
  info: props => <InfoToast {...props} {...roomForABodyLine} />,
  base: props => <BaseToast {...props} {...roomForABodyLine} />,
}
